// Generated by CoffeeScript 1.12.1
(function() {
  module.exports = require('./dns');

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/http-dns/dist/index.js
// module id = 68
// module chunks = 0